import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { InstallationFeaturesStore, WallboxDevicesWithMatchingBoilerSerial } from '@store';
import { Feature, FeatureNames, IsStringValueProperty } from '@vi-iot/client/index';
import { Observable } from 'rxjs';
import { InstallationDetailsHeaderHelper } from '../installation-details-header.helper';

@Component({
  selector: 'app-e3-wallbox-tile',
  templateUrl: './e3-wallbox-tile.component.html',
  styleUrl: './e3-wallbox-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class E3WallboxTileComponent implements OnInit {
  @Input({ required: true }) device: WallboxDevicesWithMatchingBoilerSerial;
  @Input({ required: true }) gatewaySerial: string;

  readonly imagePath = InstallationDetailsHeaderHelper.ImagePath;

  thirdPartyModel$: Observable<Feature<IsStringValueProperty, never>>;
  wallboxEtn$: Observable<Feature<IsStringValueProperty, never>>;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.thirdPartyModel$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartyModel,
      this.device.id,
      this.gatewaySerial
    );

    this.wallboxEtn$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceEtn,
      this.device.id,
      this.gatewaySerial
    );
  }
}
